// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import i18n from '@/plugins/i18n';
import App from './App';
import 'bootstrap';
import CustomParticles from './assets/particles';
import './assets/styles/main.scss';
import router from './router';

Vue.use(CustomParticles);
Vue.use(VueI18n);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  i18n,
  render: (h) => h(App),
  template: '<App/>',
  components: { App },
}).$mount('#app');
